import { styled } from '@mui/material/styles';
import { Box, Typography } from '@mui/material';

export const Container = styled(Box)({
  position: 'absolute',
  width: '100%',
  height: '100%',
  zIndex: 20,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

export const CountDownText = styled(Typography)({
  fontSize: '150px',
  textShadow: '0px 0px 14px rgba(0, 0, 0, 0.35)',
  fontFamily: 'Poppins',
});

export const RecordTimeCounterWrapper = styled(Box)({
  position: 'absolute',
  minWidth: '60px',
  width: 'auto',
  height: '28px',
  borderRadius: '30px',
  zIndex: 20,
  background: 'rgba(0, 0, 0, 0.60)',
  top: '21px',
  right: '20px',
  display: 'flex',
  alignItems: 'center',
  padding: '0 7px',
  justifyContent: 'space-between',
});

export const RecordDot = styled(Box)({
  width: '12px',
  height: '12px',
  borderRadius: '50%',
  background: '#F00',
  marginRight: '8px',
});

export const RecordTimeText = styled(Typography)({
  fontSize: '20px',
  fontWeight: 600,
  textShadow: '0px 0px 5px rgba(0, 0, 0, 0.35)',
  lineHeight: '100%',
});
